// TODO: check is qs lib nesscesary?
import qs from 'qs';

export const userAPI = {
  token: '/user/oauth/token',
  info: '/user/userInfo',
  revoke: '/user/oauth/revoke',
  sendResetPasswordEmail: email => `/crm/api/v1/user/resetPassword/email?email=${email}`,
  resetPassword: (email, newPassword, resetToken) =>
    `/crm/api/v1/user/resetPassword?email=${email}&newPassword=${newPassword}&resetToken=${resetToken}`,

  getManufacturersByCredentials: ({ username, password }) =>
    `/crm/api/v1/user/manufacturers?email=${username}&password=${password}`,

  getManufacturersByAccountId: ({ accountId }) =>
    `/crm/api/v1/user/manufacturers?userid=${accountId}`,
};

export const componentFamilyAPI = {
  list: '/component/api/v1/component_family/',
  listByType: typeId => `/component/api/v1/component_family?componentTypeId=${typeId}`,
  info: id => `/component/api/v1/component_family/${id}`,
  submit: '/component/api/v1/component_family/',
  approve: id => `/component/api/v1/component_family/${id}/approve`,
  downloadReport: (familyId, id) => `/component/api/v1/component_family/${familyId}/test-report/${id}`,
};

export const systemAPI = {
  getAvailableBoatSystemsList: '/component/api/v1/componentSystem',
  getBoatSystemStructure: id => `/component/api/v1/componentSystem/${id}`,
  saveSystem: '/component/api/v1/componentSystemValue',
  deleteSystem: systemId => `/component/api/v1/componentSystemValue?componentSystemValueId=${systemId}`,
  getComponentsByType: (typeId, isActive) =>
    `/component/api/v1/componentSystemValue/components/type/${typeId}?isManufacturerActive=${isActive}`,
  getSystemsForBoat: boatId => `/component/api/v1/componentSystemValue/${boatId}`,
  getComponent: componentIds =>
    `/component/api/v1/componentSystemValue/components?componentIds=${
      componentIds && componentIds.join ? componentIds : componentIds.join(',')
    }`,
};

export const trailerAPI = {
  trailers: '/trailer/api/v1/trailers/',
  trailersByYear: (year = 0, isInspection = false) =>
    `/trailer/api/v1/trailers?year=${year}&inspectionList=${isInspection}`,
  getPermissibleModelYears: '/trailer/api/v1/util/model/years',
  currentModelYear: '/trailer/api/v1/util/model/year',
  rollOver: trailerId => `/trailer/api/v1/rollOver${trailerId ? '/' + trailerId : ''}`,
  reactivate: trailerId => `/trailer/api/v1/trailers/reactivate?trailerId=${trailerId}`,
  deactivate: trailerId => `/trailer/api/v1/trailers/deactivate?trailerId=${trailerId}`,
  delete: trailerId => `/trailer/api/v1/trailers/${trailerId}`,
  getMMLReport: (modelYear, contact) => `/trailer/api/v1/report/mml/${modelYear}?contact=${contact}`,
  getHistoricMMLReport: (modelYear, dateString) =>
    `/trailer/api/v1/report/mml/historic/${modelYear}?date=${dateString}`,
  newTrailersCount: (modelYear, calendarYear, month) =>
    `/trailer/api/v1/trailers/number/new?year=${modelYear}&month=${calendarYear}-${month}`,
};

export const oilAPI = {
  engineTypes: '/oil/api/v1/formula/engineTypes',
  formula: id => `/oil/api/v1/formula/${id}`,
  formulasList: '/oil/api/v1/formula/',
  submitFormula: '/oil/api/v1/formula/',
  updateFormula: '/oil/api/v1/formula/update',
  approveFormula: id => `/oil/api/v1/formula/approve/${id}`,
  deactivateFormula: id => `/oil/api/v1/formula/deactivate/${id}`,
  incompleteFormula: id => `/oil/api/v1/formula/incomplete/${id}`,
  pendFormula: id => `/oil/api/v1/formula/submit/${id}`,
  changeFormulaPaymentStatus: (id, isPaid) => `/oil/api/v1/formula/paid/${id}?isPaid=${isPaid}`,
  downloadFormulaCertLetter: id => `/oil/api/v1/formula/cert/letter/${id}`,
  brand: id => `/oil/api/v1/brand/${id}`,
  brandsList: (signed, year) => `/oil/api/v1/brand${qs.stringify({ signed, year }, { addQueryPrefix: true })}`,
  submitBrand: '/oil/api/v1/brand',
  updateBrand: '/oil/api/v1/brand/update',
  approveBrand: id => `/oil/api/v1/brand/approve/${id}`,
  deactivateBrand: id => `/oil/api/v1/brand/deactivate/${id}`,
  incompleteBrand: id => `/oil/api/v1/brand/incomplete/${id}`,
  pendBrand: id => `/oil/api/v1/brand/submit/${id}`,
  rollOverBrand: id => `/oil/api/v1/rollOver/${id}`,
  downloadReport: (formulaId, reportId) => `/oil/api/v1/formula/${formulaId}/report/${reportId}`,
  downloadBrandCertLetter: id => `/oil/api/v1/brand/cert/letter/${id}`,
  eSignBrandLicense: id => `/oil/api/v1/brand/license/${id}`,
  downloadBrandDocumentsList: (id, year) => `esign/api/v1/es/brand?brandNumber=${id}&modelYear=${year}`,
  newOilBrandsCount: (modelYear, calendarYear, month) =>
    `/oil/api/v1/brand/number/new?year=${modelYear}&month=${calendarYear}-${month}`,
  downloadActiveOilReport: (modelYear) => `/oil/api/v1/brand/active/report/download?year=${modelYear}`,
  downloadActiveOilFormulationsReport: (modelYear) => `/oil/api/v1/formula/active/report/download?year=${modelYear}`,
};

export const inspectionAPI = {
  inspectionList: boatInspecFlag => `inspection/api/v1/inspect?boatInspecFlag=${boatInspecFlag}`,
  inspectionDetails: id => `inspection/api/v1/inspect/${id}`,
  submitInspectionRequest: 'inspection/api/v1/inspect/',
  incompleteReport: id => `inspection/api/v1/inspect/incomplete/${id}`,
  incompleteResponse: id => `inspection/api/v1/var/incomplete/${id}`,
  resubmitReport: id => `inspection/api/v1/inspect/resubmit/${id}`,
  approveReport: (id, isRequired = false) => `inspection/api/v1/inspect/complete/${id}/${isRequired}`,
  approveResponse: id => `inspection/api/v1/var/complete/${id}`,
  downloadReportDocument: (inspectionReportId, docId) =>
    `inspection/api/v1/doc/download/inspection/${inspectionReportId}/doc/${docId}`,
  downloadResponseDocument: (varId, reportId) => `inspection/api/v1/report/download/var/${varId}/report/${reportId}`,
  requestResponse: (id, isRequired) => `inspection/api/v1/inspect/${id}/var/${isRequired}`,
  submitVarianceResponse: id => `inspection/api/v1/var/submit/${id}`,
  saveVarianceResponse: 'inspection/api/v1/var/',
  deleteReport: id => `inspection/api/v1/inspect/${id}`,
  eSignReport: id => `inspection/api/v1/inspect/sign/${id}`,
  newBoatInspectionsCount: (modelYear, calendarYear, month) =>
    `inspection/api/v1/inspect/number/new?year=${modelYear}&month=${calendarYear}-${month}&boatInspecFlag=true`,
  newTrailerInspectionsCount: (modelYear, calendarYear, month) =>
    `inspection/api/v1/inspect/number/new?year=${modelYear}&month=${calendarYear}-${month}&boatInspecFlag=false`,
};

export const componentAPI = {
  categories: '/component/api/v1/component/categories',
  types: '/component/api/v1/component_types',
  list: '/component/api/v1/components/?includeReports=false',
  listWithoutFamily: '/component/api/v1/components/without-family',
  listWithReports: '/component/api/v1/components/test-report/list-to-copy-from',
  create: '/component/api/v1/components/',
  categoriesWithTypes: '/component/api/v1/components/categories/types',
  componentInfo: id => `/component/api/v1/components/${id}`,
  componentReportsInfo: id => `/component/api/v1/report/all/${id}`,
  downloadReport: (componentId, reportId) => `/component/api/v1/components/${componentId}/test-report/${reportId}`,
  approve: id => `/component/api/v1/components/${id}/approve`,
  deactivate: id => `/component/api/v1/components/${id}/deactivate`,
  incomplete: id => `/component/api/v1/components/${id}/incomplete`,
  reactivate: id => `/component/api/v1/components/${id}/reactivate`,
  submit: id => `/component/api/v1/components/${id}/submit`,
  newComponentsCount: (modelYear, calendarYear, month) =>
    `/component/api/v1/components/number/new?month=${calendarYear}-${month}`,
  listReport: typeIds => `/component/api/v1/component/report?componentTypeIds=${typeIds.join()}`,
};

export const manufacturerAPI = {
  addressesList: manufacturerId => `/manufacturer/api/v1/crmInfo/addresses?accountCode=${manufacturerId}`,
  list: role => `/manufacturer/api/v1/manufacturer?role=${role}`,
  inspectorsList: role => `/manufacturer/api/v1/manufacturer/inspector?inspectedRole=${role}`,
  listWithChecklistItems: (role, year, signStatus, inspectorCode, withBrands) =>
    `/manufacturer/api/v1/manufacturer/${
      withBrands ? 'withChecklistAndBoatBrands' : 'withChecklist'
    }?role=${role}&year=${year}${signStatus !== undefined ? `&signed=${signStatus}` : ''}${
      inspectorCode ? `&inspectorCode=${inspectorCode}` : ''
    }`,
  addBrand: 'manufacturer/api/v1/brand',
  deleteBrand: brandId => `/manufacturer/api/v1/brand/${brandId}`,
  details: manufacturerId => `/manufacturer/api/v1/manufacturer/${manufacturerId}`,
  changeStatus: (id, status) => `/manufacturer/api/v1/manufacturer/changeStatus/${id}?active=${status}`,
  getEngineeringContacts: manufacturerId => `/manufacturer/api/v1/manufacturer/${manufacturerId}/engineeringContacts`,
  getInspectorContacts: manufacturerId => `/manufacturer/api/v1/manufacturer/${manufacturerId}/inspectorContacts`,
  checkList: (role, year) => `manufacturer/api/v1/checklist?role=${role}&year=${year}`,
  eSignDocumentsList: (year, role) =>
    `esign/api/v1/es?manufacturerRole=${role}${year !== 'All' ? '&modelYear=' + year : ''}`,
  eSignDocumentDownload: envelopeId => `esign/api/v1/es/download?envelopeId=${envelopeId}`,
  eSignBoatCertAgreement: (year, isPWC) => `manufacturer/api/v1/cert/boat?isPWC=${!!isPWC}&year=${year}`,
  eSignComponentCertAgreement: year => `manufacturer/api/v1/cert/component?year=${year}`,
  eSignTrailerCertAgreement: year => `manufacturer/api/v1/cert/trailer?year=${year}`,
  capacityTagStatus: 'manufacturer/api/v1/capacityTag',
  micNumber: '/crm/api/v1/mic/number',
};

export const boatAPI = {
  list: '/boat/api/v1/boats/',
  create: '/boat/api/v1/boats/',
  details: boatId => `/boat/api/v1/boats/${boatId}`,
  boatByYear: year => `/boat/api/v1/boats/year/${year}`,
  approvedBoatsByYear: (year = 0, isInspection = false) =>
    `/boat/api/v1/boats/approved/year/${year}?inspectionList=${isInspection}`,
  saveCubicCapacity: '/boat/api/v1/cubicCapacity',
  savePowerCapacity: boatId => `/boat/api/v1/calcs/mpc/${boatId}`,
  checkMatrix: boatId => `/boat/api/v1/cubicCapacity/calculateArea?boatId=${boatId}`,
  calculateCapacity: boatId => `/boat/api/v1/cubicCapacity/calculateCapacity?boatId=${boatId}`,
  calculatPontoonCapacity: boatId => `/boat/api/v1/calcs/pontoon/${boatId}`,
  getEnteredCubicCapacity: boatId => `/boat/api/v1/cubicCapacity/list?boatId=${boatId}`,
  currentModelYear: '/boat/api/v1/util/model/year',
  modelYears: '/boat/api/v1/util/model/years',
  stateCodes: '/boat/api/v1/cityAndState/stateCodes',
  calculatePersonWeightCapacity: boatId => `/boat/api/v1/calcs/pw/${boatId}`,
  getFloatationTestReports: boatId => `/boat/api/v1/flotationReport/${boatId}`,
  uploadFloatationTestReports: boatId => `/boat/api/v1/flotationReport/upload/${boatId}`,
  deleteFloatationTestReports: boatId => `/boat/api/v1/flotationReport/remove/${boatId}`,
  downloadReport: (boatId, reportId) => `/boat/api/v1/flotationReport/download/boat/${boatId}/document/${reportId}`,
  getAdditionalDocs: boatId => `/boat/api/v1/additionalDoc/${boatId}`,
  uploadAdditionalDocs: boatId => `/boat/api/v1/additionalDoc/upload/${boatId}`,
  deleteAdditionalDocs: boatId => `/boat/api/v1/additionalDoc/remove/${boatId}`,
  downloadFile: (boatId, docId) => `/boat/api/v1/additionalDoc/download/boat/${boatId}/document/${docId}`,
  submit: boatId => `/boat/api/v1/boats/submit?boatId=${boatId}`,
  deactivate: boatId => `/boat/api/v1/boats/deactivate?boatId=${boatId}`,
  reactivate: boatId => `/boat/api/v1/boats/reactivate?boatId=${boatId}`,
  saveSteeringSystem: (boatId, dualSteering) =>
    `/boat/api/v1/boats/dualsteering/${boatId}?dualSteering=${dualSteering}`,
  getMMLReport: (modelYear, contact) => `/boat/api/v1/mmlReport/${modelYear}?contact=${contact}`,
  getHistoricMMLReport: (modelYear, dateString) => `/boat/api/v1/mmlReport/historic/${modelYear}?date=${dateString}`,
  getCARBReport: '/boat/api/v1/capacityTagReport/download',
  rollOver: boatId => `/boat/api/v1/rollOver/${boatId}`,
  newBoatsCount: (modelYear, calendarYear, month) =>
    `/boat/api/v1/calcs/number/new?year=${modelYear}&month=${calendarYear}-${month}`,
  approvedBoatsCount: (modelYear, calendarYear, month) =>
    `/boat/api/v1/calcs/number/approved?year=${modelYear}&month=${calendarYear}-${month}`,
  approvedActiveBoatsCount: (modelYear) =>
    `/boat/api/v1/calcs/number/approved/active?year=${modelYear}`,
  approvedCertifiedBoatsCount: (modelYear) =>
    `/boat/api/v1/calcs/number/certified?year=${modelYear}`,
  getCertifiedBrandsCount: (modelYear) =>
    `/manufacturer/api/v1/brand/certified/${modelYear}/count`,
  getActiveBrandsCount: (modelYear) =>
    `/manufacturer/api/v1/brand/active/${modelYear}/count`,
};



// WEBPACK FOOTER //
// ./src/app/api/requests.js